<div #containerEl class="text-container" [class.expanded]="expanded" [style.--max-lines]="maxLines">
  
  <div #contentEl class="text-content">
    {{ text }}
  </div>

  
</div>
<div class="toggle" *ngIf="needsToggle" (click)="toggle()">
    <span *ngIf="!expanded">Mostrar mais</span>
    <span *ngIf="expanded">Mostrar menos</span>

    <i nz-icon
       [nzType]="expanded ? 'up' : 'down'"
       class="chevron">
    </i>
  </div>